export default __webpack_public_path__ + "static/media/check-icon.52006358.svg";